module.exports = {
  // default (green), red, yellow, blue
  colorSchema: 'blue',
  urlPath: '/app/',
  appClass: 'cadspeed',
  footer: require('./footer.html'),
  pageTitle: 'CADSPEED',
  sideMenu: require('./Sidemenu.js'),
  logo: '/img/cadpeed-logo.svg',
  termsUrl: 'https://www.cadspeed.de/agb',
  privacyUrl: 'https://www.cadspeed.de/datenschutzerklaerung',
  orderStatusCodes: {
    "notstarted": "In Vorbereitung",
    "cam": "CAM / Nesting",
    "milling": "In Fertigung",
    "complete": "Fertigung abgeschlossen"
  },
  workflowTypes: {
    Annex: require('./Annex/Annex.js'),
    StlUpload: require('./StlUpload/StlUpload.js'),
    Construction: require('./Construction/Construction.js'),
    Approval: require('./Approval/Approval.js')
  },
  projectColumns: [
    'mixed',
    'creationdate',
    'lastmodified',
    'workflow',
    'status'
  ],
  orderColumns: [
    'transactionnum',
    'reference',
    'workflow',
    'date',
    'duedate',
    'status',
  ],
  hideInvoiceStatus: true,
  locales: {
    en: {
      CookieConsent: {
        message: 'This website uses cookies to ensure you get the best possible experience on our website. Intergrated third-party services may consolidate this information with further data. Cookies may contain personal data unless explicitly specified otherwise. By clicking "Select all and close", you agree to the use of these cookies and save your settings for the specified storage period. Alternatively, you can select which specific cookies you\'d like to enable and save your settings by clicking "confirm selection". You can find further information as well as the possibility of regulatory objections in our <a href="https://www.cadspeed.de/datenschutzerklaerung">Privacy Policy</a>.',
      }
    },
    de: {
      CookieConsent: {
        message: 'Diese Website verwendet Cookies, um Ihnen die bestmögliche Erfahrung zu gewährleisten. Integrierte Drittanbieter können diese Informationen mit weiteren Daten zusammenführen. Sofern nicht anders angegeben, enthalten die Cookies personenbezogene Daten. Durch Klicken auf "Alle wählen und schließen" erklären Sie sich mit der Verwendung dieser Cookies einverstanden und speichern Ihre Einstellungen. Alternativ können Sie auswählen, welche spezifischen Cookies Sie zulassen möchten und Ihre Einstellungen durch Klicken auf "Auswahl bestätigen" speichern. Weitere Informationen sowie die Widerspruchsmöglichkeit finden Sie in unseren <a href="https://www.cadspeed.de/datenschutzerklaerung">Datenschutzhinweisen</a>.',
      }
    }
  },
  features: {
    legacyGoToCart: true,
    newProjectFromDashboard: true,
    hidePrices: {
      requires: {
        '$and': [
          {'$neq': {xmlNumber: null}},
          {'$neq': {xmlNumber: undefined}}
        ]
      },
      orderConditions: {
        '$and': [
          {'$neq': {'project.data.form.xmlNumber': null}},
          {'$neq': {'project.data.form.xmlNumber': undefined}}
        ]
      }
    }
  }
}
